import { t } from '@/i18n';
import type { PayrollOverview } from '@ip/shared-types';
import { formatPct } from './chart-utils';
import { KpiTile } from './KpiTile';

/**
 * `taxWedgePct` arrives as a RATIO (0–1, 4dp), not a percentage — multiply
 * before formatting or the share reads as "0.4% daniny" instead of "40.2%".
 */
export function PayrollKpiTiles({ kpis }: { kpis: PayrollOverview['kpis'] }) {
  const wedgeShare =
    kpis.taxWedgePct != null ? formatPct(kpis.taxWedgePct * 100) : null;

  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-3 xl:grid-cols-5">
      <KpiTile
        emphasis="hero"
        caption={t('dashboard.people.employerCostYtd')}
        value={kpis.employerCostYtd}
        secondary={
          <span className="text-muted-foreground">{t('dashboard.people.employerCostHint')}</span>
        }
      />
      <KpiTile
        emphasis="hero"
        caption={t('dashboard.people.netYtd')}
        value={kpis.netYtd}
        secondary={
          <span className="text-muted-foreground">{t('dashboard.people.netHint')}</span>
        }
      />
      <KpiTile
        emphasis="hero"
        caption={t('dashboard.people.taxWedgeYtd')}
        value={kpis.taxWedgeYtd}
        secondary={
          wedgeShare != null ? (
            <span className="text-amber-600 dark:text-amber-500">
              {t('dashboard.people.taxWedgeShare', { pct: wedgeShare })}
            </span>
          ) : undefined
        }
      />
      <KpiTile
        emphasis="hero"
        caption={t('dashboard.people.avgCostPerEmployee')}
        value={kpis.avgEmployerCostPerEmployee ?? 0}
        secondary={
          <span className="text-muted-foreground">
            {t('dashboard.people.avgCostHint')}
          </span>
        }
      />
      <KpiTile
        emphasis="hero"
        caption={t('dashboard.people.headcount')}
        value={String(kpis.headcount)}
        unit={null}
        secondary={
          <span className="text-muted-foreground">{t('dashboard.people.headcountHint')}</span>
        }
      />
    </div>
  );
}
